import React from "react";
import styles from "./SHProducts.module.scss";

export const ProductDetailSkeleton = () => (
  <div data-testid="product-detail-skeleton" className={styles.detail_view}>
    <div className={styles.skeleton_image_lg} />
    <div className={styles.skeleton_detail_text}>
      <div className={styles.skeleton_line_lg} style={{ width: "55%" }} />
      <div className={styles.skeleton_line_sm} style={{ width: "30%" }} />
      <div className={styles.skeleton_line_sm} style={{ width: "20%" }} />
    </div>
  </div>
);
